import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { createPortal } from "react-dom";
import tw from "tailwind-styled-components";
import axios from "axios";
import Config from "../../Config";
import TopSearchDropdown from "../TopSearchDropdown";
import { useNavigate } from "react-router-dom";

const Topbar = () => {
    const navigate = useNavigate();
    const searchRef = useRef(null);
    const user = useSelector((state) => state.UserReducer.user);
    const [query, setQuery] = useState("");
    const [searchResult, setSearchResult] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);

    const fetchFunction = async () => {
        const response = await axios.get(`${Config.apiUrl}/tenant/search/web?searchVal=${query}`, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        });
        return response.data;
    };

    useEffect(() => {
        if (query.length < 2) {
            setData([]);
            setSearchResult([]);
            setShowDropdown(false);
            return;
        }
        const fetchData = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await fetchFunction();
                setSearchResult([]);
                if (response.list.length === 0) throw new Error("Failed to fetch data");
                const data = response?.list;
                setSearchResult(data);
                setShowDropdown(true);
            } catch (error) {
                setError(error.message);
                setShowDropdown(true);
            }
            setLoading(false);
        };
        const debounceTimer = setTimeout(fetchData, 500);
        return () => clearTimeout(debounceTimer);
    }, [query]);

    const handleSearchSelection = (selectedOption) => {
        const path = selectedOption?.status === 2
            ? `/tenantdetails/l/${selectedOption.id}/1`
            : `/tenantdetails/l/${selectedOption.id}`;

        navigate(path, {
            state: {
                tabName: 'Passbook',
                tabKey: "totalDues",
            },
        });
        setShowDropdown(false);
        setQuery("");
    };

    const handleSearchChange = (e) => {
        setError(null);
        setQuery(e.target.value);
        if (e.target.value.length >= 2) {
            setShowDropdown(true);
        }
    };

    const handleSearchFocus = () => {
        if (query.length >= 2 && (searchResult.length > 0 || error)) {
            setShowDropdown(true);
        }
    };

    return (
        <>
            <div className="bg-white/95 backdrop-blur-md fixed top-0 transition-all duration-300
          left-0 lg:left-60 
          w-full lg:w-[calc(100%-15rem)]">
                <div className="h-[65px] flex items-center justify-between px-4 md:px-6">
                    {user.userType !== 5 &&
                        <div className="flex items-center space-x-2 hidden md:flex ml-6">
                            <SearchContainer ref={searchRef} className="hidden md:block ml-10 lg:ml-2 w-[360px]">
                                <div className="
                    flex items-center gap-3
                    bg-[#F4F8FB]
                    rounded-xl
                    px-4 h-[48px]
                    transition-all duration-200   
                    focus-within:bg-white
                    focus-within:ring-2
                    focus-within:ring-[#0078BD]/10
                  ">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-4 h-4 text-gray-400"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                            d="M21 21l-4.35-4.35m1.85-5.65a7 7 0 11-14 0 7 7 0 0114 0z"
                                        />
                                    </svg>
                                    <input
                                        type="text"
                                        placeholder="Find a tenant by name, mobile or room no."
                                        className="w-full bg-transparent outline-none text-sm text-gray-700 placeholder:text-gray-400"
                                        value={query}
                                        onChange={handleSearchChange}
                                        onFocus={handleSearchFocus}
                                    />
                                </div>
                                {showDropdown && searchResult && searchResult.length > 0 && (
                                    createPortal(
                                        <TopSearchDropdown
                                            onChange={handleSearchSelection}
                                            options={searchResult}
                                            anchorRef={searchRef}
                                            setShowDropdown={setShowDropdown}
                                        />,
                                        document.body
                                    )
                                )}
                                {showDropdown && error != null && (
                                    <ul className="
                    absolute mt-2 bg-white border border-gray-200
                    rounded-lg shadow-lg
                    max-h-48 overflow-y-auto
                    w-full z-50
                  ">
                                        <li className="px-4 py-2 text-gray-500 text-sm">No results found</li>
                                    </ul>
                                )}
                            </SearchContainer>
                        </div>
                    }
                    <div className="md:hidden flex-1"></div>
                </div>
            </div>

            <div className="h-16"></div>
        </>
    );
};

const SearchContainer = tw.div`relative`;

export default Topbar;